import { storeStructure } from '../store/reducers';
import routes from '../routes/route';
import FormInputTypes from '../components/atoms/formEnums/formInputTypes';
import { IconType } from '../components/atoms/icon/icon';

export default {
  attributeName: 'livetemplates',
  isDragable: false,
  // canOpen: true,
  canEdit: true,
  canCreate: false,
  canRemove: true,
  editURL: routes.LIVETEMPLATE_EDIT,
  // modifyURL:routes.LIVE_APPS,

  emptyMessage: "You don't have Live templates yet, click on the +new button to make a new one.",
  fields: [
    {
      attributeName: 'id',
      label: 'ID',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      width: '8rem',
      helpText: 'Id of the event.',
      canOrder: true,
      canFilter: true,
      exactWidth:'80px'
    },
    {
      attributeName: 'event_type',
      label: 'Type',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      width: '12rem',
      helpText: 'Type of Live event.',
      canOrder: true,
      canFilter: true,
      exactWidth:'150px'

    },
    {
      attributeName: 'name',
      label: 'Name',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      width: '12rem',
      helpText: 'Name of Live event.',
      canOrder: true,
      canFilter: true,
    },
    {
      attributeName: 'structure',
      label: 'Cameras',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      width: '8rem',
      helpText: 'Cameras composition of live event.',
      canOrder: false,
      canFilter: false,
      className:'table__small-text',
      exactWidth:'150px'
    },

    {
      attributeName: 'created_at',
      label: 'Created At',
      width: '12rem',
      helpText: 'Date of Live event creation.',
      type: FormInputTypes.TIMESTAMP,
      canOrder: true,
      exactWidth:'250px'
    },
    {
      attributeName: 'status',
      label: 'Status',
      type: FormInputTypes.STATUS,
      helpText: 'Status of Live template.',
      exactWidth: '200px',
      colors: {
        active: 'bg-success',
        deprecated: 'bg-warning',
        inactive: 'bg-danger',
      },
    },
    {
      attributeName: 'createLink',
      label: 'Create Live from template',
      type: FormInputTypes.BUTTON_POPUP,
      icon: IconType.NEW,
      width: '4rem',
      target:'_self',
      iconSize:'2x',
      iconColor:'#17a2b8',
      helpText: 'Create new Live from this template.',
      redirectUrl:'lives',
      actionUrl:'liveCreationFromTemplateButton',
      exactWidth:'150px',
      formConfig:
        {
          title: 'New live from template',
          description:'Create a new live from this template selected. Please choose a name for the live event to continue',
          attributeName: 'newLiveTemplate',
          fields: [
            {
              attributeName: 'name',
              helpText: 'Name of the new live',
              type: FormInputTypes.TEXT_INPUT.TEXT,
              required: true,
              label: 'Name',
              placeholder: 'Please enter the name of new live event',
            },
            {
              attributeName: 'deployment',
              helpText: 'Deployment',
              type: FormInputTypes.SELECT,
              label: 'Deployment',
              placeholder: 'Please enter to add Deployment code...',
              multiple: false,
              url: 'livedeploymentslist',
              sessionParams: ['type'],
              emptyValue:true,
              default:'(Empty)', //default value to empty option
              fieldValue:'coderegionvalue',
              fieldName:'coderegiontext',
              asyncSelect: true,
              options:[],
            },
          ]
        }
    },   
  ],
};
